
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { BoxStatusType } from '@/types';

@Component
export default class TooltipStatusLabel extends Vue {
  @Prop({ type: String, default: 'todo' }) readonly status!: BoxStatusType | null
  @Prop({ type: String, default: '' }) readonly statusLabel!: string
  @Prop({ type: String, default: '' }) readonly label!: string

  get boxColor(): string {
    switch (this.status) {
      case 'na':
      case 'todo':
        return 'grey';

      case 'done':
        return 'success';

      case 'waiting':
        return 'orange';

      default:
        break;
    }

    return '';
  }

  get boxDark(): boolean {
    switch (this.status) {
      case 'todo':
      case 'done':
      case 'waiting':
        return true;

      case 'na':
        return false;

      default:
        break;
    }

    return true;
  }

  get boxOutlined(): boolean {
    switch (this.status) {
      case 'todo':
      case 'done':
      case 'waiting':
        return false;

      case 'na':
        return true;

      default:
        break;
    }

    return false;
  }
}

